import './list.scss';
import { useSize } from 'ahooks';
import ListLeft from './listLeft';
import { lang } from '@umu/ukit-lang';
import { Modal } from '@umu/umu-design';
import { Checkbox, ListItem, CHECKBOX_CHECK_TYPE } from './listItem';
import { DepartmentSearch } from '../departmentSearch/departmentSearch';
import {
    getNotInDepartmentMemberList,
    getSugMemberList,
    getMemberInfoByUmuIds as getMemberInfoByUmuIdsService,
    getSEDepartmentIdsService,
    getDepartmentDataService,
} from '../../service';
import {
    DefaultSelectDepartmentItem,
    GetDepartmentData,
    IDListRef,
    IDepartmentList,
    IListItem,
    IListProps,
    IMemberList,
    IRoute,
    ISubDepartInfo,
    ISugDepartListInfo,
    SectionType,
    TravelType,
} from '../../type';
import { DialogContext, DIALOG_ACTION_TYPE, IDepartmentCache } from '../../DialogContext';
import React, { useState, useContext, useEffect, useImperativeHandle, forwardRef, useRef } from 'react';
import {
    getDepartmentListByLevel,
    IDepartListInfo,
    getDepartmentListByManagerId,
    getDepartmentList,
    IDepartListInfo as ISubDepartListInfo,
    getSubDepartmentList,
    getSugDepartment,
    getMemberList,
    IMemberListInfo,
} from '@umu/umu-api';
import {
    compare,
    genNotInSeDepartmentData,
    genRootDepartmentData,
    genRootDepartmentOriData,
    getAllUseSelectedDepartmentIds,
    getSelectableUseDepartmentIdsSetRef,
    isLoadEnd,
    isOriginStructure,
    isRootDepartment,
    limitSelectedCount,
    normMemberItem,
    originBreadcrumbItem,
    originStructureId,
    rootDepartmentId,
} from '../../dataflow';
import {
    cleanSelectedState,
    onSellectChange,
    setCleanDataList,
    setDepartmentCacheState,
    setDepartmentSelectedMap,
    setIsSearchMode,
    setListItemState,
    setListState,
    setMemberSelectedMap,
    setSugState,
    updateListItemState,
} from '../../DialogContextSet';
import { $document } from '@umu/umu-dom';

const { confirm } = Modal;
import { If, Loading, Breadcrumb } from 'common/src/components';

function DList(props: IListProps, ref: React.Ref<IDListRef>) {
    const {
        useId,
        isLoading,
        isShowMember,
        btnType,
        setIsLoading,
        isOnlyShowRightList = false,
        notInSeDepartmentValue = '1',
        defaultSelectedMemberList = [],
        isShowNotInSeDepartment = false,
        defaultSelectedDepartmentList = [],
        isCanClickOriginStructure = true,
        isCanSelectParentDepartment = false,
        isOnlyShowUSESelectedDepartment = false,
        isMutualExclusionOfNotInSeDepartment = true,
        notInSeDepartmentLabel = lang('不属于上述部门'),
    } = props;

    const context = useContext(DialogContext);
    const [isAllSelect, setIsAllSelect] = useState<CHECKBOX_CHECK_TYPE>(CHECKBOX_CHECK_TYPE.UN_CHECK);
    const [breadcrumbRoutes, setBreadcrumbRoutes] = useState<IRoute[]>([originBreadcrumbItem]);
    const memberListRequestIdRef = useRef(Symbol()); // 请求唯一标识, 用于解决竞态问题
    const dataListCache = useRef<{ [key: string]: { data: IListItem[]; pInfo?: any }[] }>({});
    const originStructureDataRef = useRef<IDepartListInfo | null>(null);
    const breadcrumbRef = useRef<HTMLDivElement | null>(null);
    const breadcrumbSize = useSize(breadcrumbRef);

    // 可选的 USE 部门列表：场景为 在所有 USE 的部门列表中，有一些是子级可以选中，但是父级不可以被选中
    const selectableUseDepartmentIdsSetRef = useRef<Set<string>>(new Set());
    // 所有 USE 部门列表
    const allUseSelectedDepartmentIdsSetRef = useRef<Set<string>>(new Set());

    const {
        role,
        dataList = [],
        isSearchMode = false,
        departmentCache,
        enterpriseName,
        selectedList,
        pageInfo,
        uplevelDepartment,
        uplevelIdMap,
    } = context.state;
    const dispatch = context.dispatch;

    /**
     * @description: 右列表普通数据
     */
    const showDataListRight = selectedList;
    const selectedNum = showDataListRight.length;

    /**
     * @description: 验证选中是否超出最大限制 ， 最大为 300
     * @param {string} type
     */
    const validateSelectedCount = (type: string) => {
        let flag = true;
        flag =
            type === 'all'
                ? showDataListRight.length + dataList.length > limitSelectedCount
                : showDataListRight.length + 1 > limitSelectedCount;

        if (flag) {
            confirm({
                title: lang('操作超限'),
                content: lang('“已选”数量超出上限${0}的限制，本次操作不生效。').replace('${0}', limitSelectedCount),
                okText: lang('知道了'),
                centered: true,
                zIndex: 99999,
                onOk() {
                    // console.log();
                },
            });
            return false;
        }
        return true;
    };

    /**
     * @description: 是否可以点击 组织架构
     * @param {IRoute} item
     * 学习负责人  - 有权限
     * 系统管理员  - 有权限
     */
    const isHasPermissionOfBreadcrumb = (item: IRoute) => {
        if (item.path === originStructureId && !isCanClickOriginStructure) {
            return false;
        }

        return item.path === originStructureId ? role.isAdmin || role.isManage : true;
    };

    /**
     * @description: 是否可以点击 全选
     */
    const isHasPermissionOfAllSelect = () => {
        // 讲师不可全选根目录
        if (role.isTeacher && Number(departmentCache.currDepartmentId === rootDepartmentId)) {
            return false;
        }
        return true;
    };

    /**
     * @description: 是否可以查看部门成员
     * @param {IDepartmentCache} dCache
     */
    const isHasPermissionOfMember = (dCache: IDepartmentCache) => {
        if (role.isManage && isRootDepartment(dCache.currDepartmentId)) {
            return false;
        } else if (role.isManage && Number(dCache.manage_permission) !== 1) {
            return false;
        }
        return true;
    };

    /**
     * @description: 是否可以点击 下一级部门
     * @param {IDepartmentList} departmentItem
     */
    const isHasPermissionOfLastLevelDepartment = (departmentItem: any) => {
        if (
            role.isManage &&
            (!departmentItem.child_path || departmentItem.child_path.length === 0) &&
            Number(departmentItem.manage_permission) !== 1
        ) {
            return false;
        }

        if ((!departmentItem.child_path || departmentItem.child_path.length === 0) && !isShowMember) {
            return false;
        }

        return true;
    };

    const handleAllSelect = (e: boolean) => {
        if (e && !validateSelectedCount('all')) {
            return;
        }
        onSellectChange(context, e, {
            isCanSelectParentDepartment,
            selectableUseDepartmentIdsSet: selectableUseDepartmentIdsSetRef.current,
        });
    };

    const sugDepartmentData = async (keywords: string) => {
        let paramsSug = {
            keywords,
        };
        if (props.source) {
            paramsSug = Object.assign(paramsSug, { source: props.source });
        }
        if (props.expendParams) {
            paramsSug = Object.assign(paramsSug, { ...props.expendParams });
        }
        const data: IListItem[] = [];
        try {
            let list: ISugDepartListInfo[] = await getSugDepartment(paramsSug);

            if (isOnlyShowUSESelectedDepartment) {
                list = list.filter((item) => allUseSelectedDepartmentIdsSetRef.current.has(String(item.department_id)));
            }

            if (!list) {
                return data;
            }

            list.forEach((item) =>
                data.push(
                    Object.assign(
                        { isSelected: false, type: TravelType.department, checkable: true },
                        {
                            name: item.department_name,
                            id: item.department_id,
                            manage_permission: item.manage_permission,
                            oriData: { ...item, exclude_umu_ids: [] },
                        },
                    ),
                ),
            );
        } catch (_error) {}
        return data;
    };

    const sugMemberData = async (requestId: Symbol, keywords: string) => {
        const data: IListItem[] = [];
        if (!isShowMember) {
            return data;
        }

        const params = {
            keyword: keywords,
            department_id: props.departmentId!,
            page: 1,
            size: 500,
            from: 2,
            exclude_resigned_user: 1, //1为过滤离职用户，0不过滤离职用户
        };

        try {
            const listInfo: IMemberListInfo = await getSugMemberList(params);
            if (!listInfo || !listInfo.list) {
                return data;
            }

            if (requestId === memberListRequestIdRef.current) {
                listInfo.list.forEach((item) => data.push(normMemberItem(item)));
            }
        } catch (_error) {}
        return data;
    };

    /**
     * 获取当前用户可以管理的部门列表，及父部门列表并缓存起来，
     */
    const loadUplevelDepartment = () => {
        const uplevelDepartmentList: IListItem[] = [];
        let paramsLevel = {};
        if (props.access) {
            paramsLevel = Object.assign(paramsLevel, { type: props.access });
        }
        if (props.source) {
            paramsLevel = Object.assign(paramsLevel, { source: props.source });
        }
        if (props.expendParams) {
            paramsLevel = Object.assign(paramsLevel, { ...props.expendParams });
        }
        if (role.isManage) {
            paramsLevel = Object.assign(paramsLevel, { type: '"0"' });
        }
        return getDepartmentListByManagerId(paramsLevel).then((info: IDepartListInfo) => {
            let list: IDepartmentList[] = info.department_list;

            if (isOnlyShowUSESelectedDepartment) {
                list = list.filter((item) => allUseSelectedDepartmentIdsSetRef.current.has(String(item.department_id)));
            }

            const parentIdMap: {
                [key: string]: string;
            } = {};
            parentIdMap['-1'] = '0';
            let upId = '0';

            const defaultSelectedItem = defaultSelectedDepartmentList.find((item) => Number(item.id) === 0);

            uplevelDepartmentList.push({
                isSelected: !!defaultSelectedItem,
                checkable: true,
                type: TravelType.department,
                name: info.show_name || '',
                id: rootDepartmentId,
                oriData: {
                    department_id: rootDepartmentId,
                    department_name: info.show_name || '',
                    manage_permission: info.manage_permission,
                    exclude_umu_ids: [],
                },
                isHaveNextLevel: true,
                manage_permission: info.manage_permission,
            });

            // 分两步进行的原因：有限显示有权限的部门，
            list.forEach((item: IDepartmentList) => {
                uplevelDepartmentList.push({
                    isSelected: false,
                    checkable: true,
                    type: TravelType.department,
                    name: item.department_name,
                    id: item.department_id,
                    isHaveNextLevel: isHasPermissionOfLastLevelDepartment(item),
                    oriData: Object.assign(item, {
                        exclude_umu_ids: [],
                    }),
                    manage_permission: item.manage_permission,
                });
                parentIdMap[item.parent_department_id] = parentIdMap[item.parent_department_id]
                    ? parentIdMap[item.parent_department_id] + ',' + item.department_id
                    : item.department_id;
            });
            list.forEach((item: IDepartmentList) => {
                let currId = item.department_id;
                if (item.parent_path && item.parent_path.length > 0) {
                    item.parent_path.forEach((p: any, index: number) => {
                        currId = p.department_id;
                        parentIdMap[upId] = parentIdMap[upId] ? parentIdMap[upId] + ',' + currId : currId;
                        uplevelDepartmentList.push({
                            isSelected: false,
                            type: TravelType.department,
                            name: p.department_name,
                            id: p.department_id,
                            isHaveNextLevel: true,
                            oriData: {
                                department_name: p.department_name,
                                department_id: p.department_id,
                                parent_path: item.parent_path.slice(0, index),
                                parent_department_id: upId,
                                exclude_umu_ids: [],
                            },
                            manage_permission: p.manage_permission,
                        });
                        upId = currId;
                    });
                    upId = '0';
                }
            });

            dispatch({
                type: DIALOG_ACTION_TYPE.SET_UPLEVEL_DEPARTMENT,
                payload: {
                    uplevelDepartmentList,
                    uplevelIdMap: parentIdMap,
                },
            });
            const dCache: IDepartmentCache = {
                currDepartmentId: rootDepartmentId,
                currDepartmentName: info.show_name,
                upLevelDepartmentId: originStructureId,
                parents: [],
                children: [],
            };

            if (isShowNotInSeDepartment) {
                const notInSeDepartmentItem: IListItem = genNotInSeDepartmentData({
                    label: notInSeDepartmentLabel,
                    value: notInSeDepartmentValue,
                });
                uplevelDepartmentList.push(notInSeDepartmentItem);
            }

            originStructureDataRef.current = { ...info };
            setDepartmentCacheState(context, (info && info.show_name) || null, dCache);
            return Promise.resolve(uplevelDepartmentList);
        });
    };

    const loadDepartmentInfoData = async (departmentId: string) => {
        let info;
        let dCache;
        if (isOriginStructure(departmentId)) {
            info = originStructureDataRef.current!;
            dCache = {
                currDepartmentId: originStructureId,
                currDepartmentName: originBreadcrumbItem.name,
                upLevelDepartmentId: originStructureId,
                parents: [],
                children: [genRootDepartmentOriData(info!)],
            };
            setDepartmentCacheState(context, (info && info.show_name) || null, dCache!);
        } else if (isRootDepartment(departmentId)) {
            info = originStructureDataRef.current!;
            dCache = {
                currDepartmentId: rootDepartmentId,
                currDepartmentName: info.show_name,
                upLevelDepartmentId: originStructureId,
                parents: [],
                children: [],
            };
            setDepartmentCacheState(context, info.show_name, dCache);
        } else {
            const params = {
                department_id: departmentId,
            };
            info = (await getSubDepartmentList(params)) as ISubDepartInfo;
            dCache = {
                currDepartmentId: info.department_id,
                currDepartmentName: info.department_name,
                upLevelDepartmentId: info.parent_department_id,
                parents: info.parent_path,
                children: info.child_path,
                manage_permission: info.manage_permission,
            };
            setDepartmentCacheState(context, (info && info.enterprise_show_name) || null, dCache!);
        }
        memberListRequestIdRef.current = Symbol();
        loadDepartmentAndMemberData(dCache!, memberListRequestIdRef.current);
    };

    const loadDepartmentData = async (departmentId?: string) => {
        let paramsDepartment: any = {};
        if (props.access) {
            paramsDepartment = Object.assign(paramsDepartment, { type: props.access });
        }
        if (props.source) {
            paramsDepartment = Object.assign(paramsDepartment, { source: props.source });
        }
        if (props.expendParams) {
            paramsDepartment = Object.assign(paramsDepartment, { ...props.expendParams });
        }
        const pInfo = {};
        const retData: IListItem[] = [];
        try {
            const tmpMap: { [key: string]: string } = {};
            if (isOriginStructure(departmentId)) {
                let info = originStructureDataRef.current;
                if (!info) {
                    role.isManage && (paramsDepartment = Object.assign(paramsDepartment, { type: '"0"' }));
                    info = await getDepartmentListByManagerId(paramsDepartment);
                }
                retData.push(genRootDepartmentData(info!));
            } else if (isRootDepartment(departmentId)) {
                paramsDepartment.level = 1;
                const res: IResponse<IDepartListInfo> = await getDepartmentListByLevel(paramsDepartment);
                const info = res.data;
                let list: IDepartmentList[] = info.department_list;

                if (isOnlyShowUSESelectedDepartment) {
                    list = list.filter((item) =>
                        allUseSelectedDepartmentIdsSetRef.current.has(String(item.department_id)),
                    );
                }

                list.sort(compare('show_index'));

                list.forEach((item: IDepartmentList) => {
                    tmpMap[item.department_id] = '1';
                    retData.push(
                        Object.assign(
                            { isSelected: false, type: TravelType.department, checkable: true },
                            {
                                name: item.department_name,
                                id: item.department_id,
                                oriData: Object.assign(item, {
                                    exclude_umu_ids: [],
                                }),
                                manage_permission: item.manage_permission,
                                isHaveNextLevel: isHasPermissionOfLastLevelDepartment(item),
                            },
                        ),
                    );
                });
                const tmpData: IListItem[] = loadDepartmentFromUplevel(departmentId) || [];
                tmpData.forEach((item: IListItem) => {
                    if (!tmpMap[item.id]) {
                        retData.push(item);
                    }
                });

                if (isShowNotInSeDepartment) {
                    const notInSeDepartmentItem: IListItem = genNotInSeDepartmentData({
                        label: notInSeDepartmentLabel,
                        value: notInSeDepartmentValue,
                    });
                    retData.push(notInSeDepartmentItem);
                }
            } else {
                paramsDepartment.department_id = departmentId;
                const subData: ISubDepartListInfo = await getDepartmentList(paramsDepartment);
                if (!subData) {
                    return { data: retData, pInfo };
                }
                let list: IDepartmentList[] = subData.department_list;

                if (isOnlyShowUSESelectedDepartment) {
                    list = list.filter((item) =>
                        allUseSelectedDepartmentIdsSetRef.current.has(String(item.department_id)),
                    );
                }

                list.sort(compare('show_index'));

                list.forEach((item: IDepartmentList) => {
                    tmpMap[item.department_id] = '1';
                    retData.push(
                        Object.assign(
                            { isSelected: false, type: TravelType.department, checkable: true },
                            {
                                name: item.department_name,
                                id: item.department_id,
                                oriData: Object.assign(item, {
                                    exclude_umu_ids: [],
                                }),
                                manage_permission: item.manage_permission,
                                isHaveNextLevel: isHasPermissionOfLastLevelDepartment(item),
                            },
                        ),
                    );
                });

                // 将没有权限，但是子部门有权限的部门假如列表
                const tmpData: IListItem[] = loadDepartmentFromUplevel(departmentId) || [];
                tmpData.forEach((item: IListItem) => {
                    if (!tmpMap[item.id]) {
                        retData.push(item);
                    }
                });
            }
        } catch (_error) {
            console.error('loadDepartmentData:_error', _error);
        }

        return { data: retData, pInfo };
    };

    const loadDepartmentFromUplevel = (departmentId?: string): IListItem[] => {
        const list: IListItem[] = [];
        const id = departmentId ? departmentId : rootDepartmentId;
        let ids = (uplevelIdMap[id] && uplevelIdMap[id].split(',')) || [];
        ids = Array.from(new Set(ids));
        ids.forEach((i) => {
            if (uplevelDepartment[i]) {
                list.push(uplevelDepartment[i]);
            }
        });
        return list;
    };

    const loadMemberData = async (requestId: Symbol, dCache: IDepartmentCache) => {
        let pInfo: any = pageInfo;
        const data: IListItem[] = [];
        const departmentId = dCache.currDepartmentId;

        /**
         * @description: 以下场景不需要请求 成员 接口
         * 1. 当前用户是学习负责人，且不是该部门负责人
         * 2. 如果当前是在 组织架构
         * 3. 不展示成员
         */
        if (!isHasPermissionOfMember(dCache) || departmentId === originStructureId || !isShowMember) {
            return { data, pInfo };
        }

        const handler = async (isMore = false) => {
            const params = {
                department_id: dCache.currDepartmentId || rootDepartmentId,
                page: isMore ? pInfo.currentPage + 1 : 1,
                size: pInfo.size,
                from: 2, // 1: 从部门管理列表进入 2:从学习任务部门搜索列表进入
                include_sub_department: 0, // 1为包含子部门成员，0为不包含
            };

            try {
                const listInfo: IMemberListInfo = isRootDepartment(params.department_id)
                    ? await getNotInDepartmentMemberList(params)
                    : await getMemberList(params);

                if (!listInfo || !listInfo.list) {
                    return { data, pInfo };
                }

                if (requestId === memberListRequestIdRef.current) {
                    listInfo.list.forEach((item: IMemberList) => data.push(normMemberItem(item)));
                    pInfo = {
                        size: listInfo.page_info.size,
                        totalPage: listInfo.page_info.total_page_num,
                        count: listInfo.page_info.list_total_num,
                        currentPage: listInfo.page_info.current_page,
                    };
                    if (!isLoadEnd(listInfo.page_info)) {
                        await handler(true);
                    }
                }
            } catch (_error) {
                console.error('loadMemberData:_error', _error);
            }
            return true;
        };

        const cache = dataListCache.current[departmentId!]?.[1];
        if (!cache) {
            await handler(false);
            return { data, pInfo };
        }
        return cache;
    };

    const loadRootDepartmentAndMemberData = async (uplevelDepartmentList: IListItem[], requestId: Symbol) => {
        setIsLoading?.(true);
        setCleanDataList(context);

        const showDepartmentList: IListItem[] = [];
        const departmentMapId: {
            [key: string]: string;
        } = {};
        uplevelDepartmentList.forEach((i: IListItem) => {
            if (i.oriData.parent_department_id === rootDepartmentId) {
                if (departmentMapId[i.id]) {
                    return;
                }
                departmentMapId[i.id] = i.id;
                showDepartmentList.push(i);
            }
        });

        const sortList: IListItem[] = showDepartmentList.sort((a: IListItem, b: IListItem) => {
            return Number(a.oriData.show_index) - Number(b.oriData.show_index);
        });
        const memberData = await loadMemberData(requestId, departmentCache);

        if (requestId === memberListRequestIdRef.current) {
            !dataListCache.current?.[rootDepartmentId]?.[1] &&
                (dataListCache.current[rootDepartmentId] = [{ data: sortList }, memberData]);
            setListState(context, [{ data: sortList }, memberData], rootDepartmentId, {
                notInSeDepartmentValue,
                isCanSelectParentDepartment,
                isMutualExclusionOfNotInSeDepartment,
                selectableUseDepartmentIdsSet: selectableUseDepartmentIdsSetRef.current,
            });
            setIsLoading?.(false);
        }
    };

    const loadDepartmentAndMemberData = async (dCache: IDepartmentCache, requestId: Symbol) => {
        const departmentId = dCache.currDepartmentId;
        setIsLoading?.(true);
        setCleanDataList(context);

        const result = await Promise.all([loadDepartmentData(departmentId), loadMemberData(requestId, dCache)]);

        if (requestId === memberListRequestIdRef.current) {
            setListState(context, result, departmentId, {
                notInSeDepartmentValue,
                isCanSelectParentDepartment,
                isMutualExclusionOfNotInSeDepartment,
                selectableUseDepartmentIdsSet: selectableUseDepartmentIdsSetRef.current,
            });
            !dataListCache.current[departmentId] && (dataListCache.current[departmentId] = result);
            setIsLoading?.(false);
        }
    };

    const sugDepartmentAndMemberData = async (keywords: string, requestId: Symbol) => {
        setIsLoading?.(true);
        setCleanDataList(context);

        if (requestId === memberListRequestIdRef.current) {
            const result = await Promise.all([sugDepartmentData(keywords), sugMemberData(requestId, keywords)]);
            setIsLoading?.(false);
            setSugState(context, result);
        }
    };

    const onClickRemove = (value: IListItem) => {
        setListItemState(context, false, value);
    };

    const onClickFilter = (value: IListItem) => {
        updateListItemState(context, value);
    };

    const checkoutIsAllSelect = (list: IListItem[]) => {
        if (!props.isAllowSelect) {
            return;
        }
        const filterData = list.filter((item) => {
            return item.isSelected;
        });
        let checkStatus = !!filterData.length ? CHECKBOX_CHECK_TYPE.UNKNOWN_CHECK : CHECKBOX_CHECK_TYPE.UN_CHECK;
        if (filterData.length === list.length && !!list.length) {
            checkStatus = CHECKBOX_CHECK_TYPE.IS_CHECK;
        }
        setIsAllSelect(checkStatus);
    };
    const onNextLevel = (value: IListItem) => {
        if (value.isDisabledNextLevel) {
            return;
        }

        setIsLoading?.(true);
        loadDepartmentInfoData(value.id);
    };

    const onSelectedChange = (params: IListItem, isChecked: any) => {
        if (!validateSelectedCount('single')) {
            return;
        }

        setListItemState(context, isChecked, params, {
            notInSeDepartmentValue,
            isCanSelectParentDepartment,
            isMutualExclusionOfNotInSeDepartment,
            selectableUseDepartmentIdsSet: selectableUseDepartmentIdsSetRef.current,
        });
    };

    const charFilterSpaces = (value: string) => {
        const result = value.replace(/\s+/g, '');
        return result.length > 0;
    };

    const getMemberInfoByUmuIds = async (umu_ids: string) => {
        if (!umu_ids) {
            return [];
        }
        try {
            const result = await getMemberInfoByUmuIdsService({ umu_ids });
            return result.list.map((item: IMemberList) => normMemberItem(item)) as IListItem[];
        } catch (error) {
            console.error('getMemberInfoByUmuIds 发生错误', error);
            return [];
        }
    };

    /**
     * @description: 根据 departmentId 获取部门信息
     * @param {string} departmentId
     */
    const getDepartmentInfoByDepartmentId = async (item: DefaultSelectDepartmentItem) => {
        const { id, exclude_umu_ids } = item;
        if (!id || id === rootDepartmentId) {
            const originStructureData = originStructureDataRef.current!;
            const result = genRootDepartmentOriData(originStructureData!);
            return Object.assign({}, result, {
                checkable: true,
                isSelected: true,
                id: rootDepartmentId,
                type: TravelType.department,
                name: result.department_name,
                oriData: Object.assign({}, result, {
                    exclude_umu_ids: exclude_umu_ids,
                }),
                manage_permission: result.manage_permission,
                isHaveNextLevel: isHasPermissionOfLastLevelDepartment(result),
            }) as IListItem;
        }
        const params = {
            department_id: id,
        };
        const subDepartmentData: ISubDepartInfo = await getSubDepartmentList(params);
        const listItem: IListItem = Object.assign(
            { isSelected: true, type: TravelType.department, checkable: true },
            {
                name: subDepartmentData.department_name,
                id: subDepartmentData.department_id,
                oriData: Object.assign(subDepartmentData, {
                    exclude_umu_ids: exclude_umu_ids,
                }),
                manage_permission: subDepartmentData.manage_permission,
                isHaveNextLevel: isHasPermissionOfLastLevelDepartment(subDepartmentData),
            },
        );
        return listItem;
    };

    /**
     * @description: 根据默认数据获取具体信息
     * 默认部门数据 defaultSelectedMemberList
       默认成员数据 defaultSelectedDepartmentList
     */
    const handleDefaultSelectedList = async () => {
        const memberUmuIds = defaultSelectedMemberList.map((item) => item.id).join(',');
        const memberResult = await getMemberInfoByUmuIds(memberUmuIds);
        setMemberSelectedMap(context, memberResult);

        const departmentRequestQueue: Promise<IListItem>[] = [];
        defaultSelectedDepartmentList.forEach((item) => {
            departmentRequestQueue.push(getDepartmentInfoByDepartmentId(item));
        });
        const departmentResult = await Promise.all(departmentRequestQueue);
        setDepartmentSelectedMap(context, departmentResult);
    };

    const searchCallback = async (keywords: string | undefined | null) => {
        memberListRequestIdRef.current = Symbol();
        if (keywords && charFilterSpaces(keywords)) {
            setIsSearchMode(context, true);
            sugDepartmentAndMemberData(keywords, memberListRequestIdRef.current);
        } else {
            setIsSearchMode(context, false);
            loadDepartmentAndMemberData(departmentCache, memberListRequestIdRef.current);
        }
    };

    function renderItem(item: any, index: number) {
        if (!item || !item.id) {
            return <></>;
        }

        return (
            <ListItem
                role={role}
                itemData={item}
                index={index}
                limit={props.limit}
                travelType={item.type}
                sectionType={props.section}
                onClickRemove={onClickRemove}
                onClickFilter={onClickFilter}
                onNextLevel={onNextLevel}
                selectedNum={selectedNum}
                onSelectedChange={onSelectedChange}
                onToggleName={onToggleName}
                enterpriseName={enterpriseName}
                isSearchMode={isSearchMode}
            />
        );
    }

    const renderSearch = () => {
        if (props.section === SectionType.left) {
            let emptyDiv = null;
            if (dataList.length < 1 && isSearchMode && !isLoading) {
                emptyDiv = (
                    <div className="list-header-empty">
                        <span className="name">{lang('暂无搜索结果')}</span>
                    </div>
                );
            }
            return (
                <div className="search">
                    <DepartmentSearch searchCallback={searchCallback} btnType={btnType} />
                    {emptyDiv}
                </div>
            );
        } else {
            return null;
        }
    };

    const onToggleName = (params: IListItem) => {
        setListItemState(context, !params.isSelected, params);
    };

    const adaptiveHeadRight = () => {
        const headRightDom = document.querySelector('.normalize-head .normalize-head-right') as HTMLDivElement;
        const rightFilterDom = document.querySelector(
            '.list-department-item-right .list-right-filter',
        ) as HTMLDivElement;
        const rightRemoveDom =
            (document.querySelector('.list-department-item-right .list-right-remove') as HTMLDivElement) ||
            (document.querySelector('.list-item-owner-right .list-right-remove') as HTMLDivElement);

        if (!headRightDom) {
            return;
        }
        if (!rightFilterDom) {
            headRightDom.style.width = rightRemoveDom.offsetWidth + 'px';
        } else {
            headRightDom.style.width = rightFilterDom.offsetWidth + rightRemoveDom.offsetWidth + 'px';
        }
    };

    const breadCrumbItemClick = (item: IRoute, _isCurrent?: boolean) => {
        if (!isHasPermissionOfBreadcrumb(item)) {
            return;
        }

        setIsLoading?.(true);
        loadDepartmentInfoData(item.path!);
    };

    const addBreadcrumbItem = () => {
        const name = departmentCache.currDepartmentName;
        const departmentId = departmentCache.currDepartmentId;
        if (!name) {
            return;
        }
        const item = {
            name,
            path: departmentId,
        };
        setBreadcrumbRoutes((prev) => {
            const index = prev.findIndex((i) => i.path === item.path);
            if (index === -1) {
                return [...prev, item];
            }
            prev[index].name = name;
            return prev.slice(0, index + 1);
        });
    };

    const renderBreadcrumbItem = (item: IRoute, isCurrent: boolean) => {
        return (
            <div
                className={`breadcrumb-item ${isCurrent ? 'is-current' : ''} ${
                    isHasPermissionOfBreadcrumb(item) ? 'is-can-click' : 'is-disabled'
                }`}
                onClick={() => breadCrumbItemClick(item, isCurrent)}
            >
                {item.name}
            </div>
        );
    };

    const renderAllSelect = () => {
        return (
            <div className="is-all-select">
                <div className="check-box">
                    <Checkbox
                        isChecked={isAllSelect}
                        onChange={(e) => handleAllSelect(e)}
                        disabledCheck={!isHasPermissionOfAllSelect() || isLoading}
                    />
                </div>
                <div className="select-all-text">{props.allSelectText || lang('全选')}</div>
            </div>
        );
    };

    const renderListLeft = () => {
        if (isOnlyShowRightList) {
            return null;
        }

        return (
            <>
                {!isSearchMode ? (
                    <div ref={breadcrumbRef}>
                        <Breadcrumb routes={breadcrumbRoutes} itemRender={renderBreadcrumbItem} />
                    </div>
                ) : null}
                {isLoading ? (
                    <Loading />
                ) : (
                    <ListLeft
                        isSearchMode={isSearchMode}
                        dataList={dataList}
                        renderItem={renderItem}
                        breadcrumbSize={breadcrumbSize}
                    />
                )}
            </>
        );
    };

    const renderListRight = () => {
        return (
            <>
                <If condition={showDataListRight.length !== 0}>
                    <div className="normalize-head">
                        <span className="normalize-head-left">
                            {isShowMember ? lang('已选部门或已选账户') : lang('已选部门')}
                        </span>
                        <span className="normalize-head-right">{lang('操作')}</span>
                    </div>
                </If>

                <div className="normalize-list-container">
                    <div className="normalize-list-wrapper">
                        {showDataListRight.map((item, index) => {
                            return <div key={item.id}>{renderItem(item, index)}</div>;
                        })}
                    </div>
                </div>
            </>
        );
    };

    const initAllDepartment = () => {
        loadUplevelDepartment().then(async (uplevelDepartmentList: IListItem[]) => {
            await handleDefaultSelectedList();
            if (!isOriginStructure(props.departmentId) && !isRootDepartment(props.departmentId)) {
                loadDepartmentInfoData(props.departmentId!);
            } else {
                memberListRequestIdRef.current = Symbol();
                loadRootDepartmentAndMemberData(uplevelDepartmentList, memberListRequestIdRef.current);
            }
        });
    };

    const normalizeUSESelectedDepartmentList = (
        selectedDepartmentIdList: string[],
        departmentTreeList: GetDepartmentData[],
        path: string[],
        isSelectedParented = false,
    ): GetDepartmentData[] => {
        return departmentTreeList.map((item) => {
            const isSelected = selectedDepartmentIdList.some((id) => id === item.id);
            const mergedIsSelected = isSelected || isSelectedParented;

            return {
                id: item.id,
                name: item.name,
                path: path ?? [],
                parent_id: item.parent_id,
                children: item.children
                    ? normalizeUSESelectedDepartmentList(
                          selectedDepartmentIdList,
                          item.children,
                          path ? [...path, item.id] : [item.id],
                          mergedIsSelected,
                      )
                    : [],
                disabled: !mergedIsSelected,
            };
        });
    };

    const initOnlyShowUSESelectedDepartment = async () => {
        try {
            const { department_ids } = await getSEDepartmentIdsService({
                se_id: useId,
            });

            if (department_ids && department_ids.length) {
                const useSelectedDepartmentData = await getDepartmentDataService({
                    department_ids: department_ids.join(','),
                });

                const normalizedUSESelectedDepartmentList = normalizeUSESelectedDepartmentList(
                    department_ids,
                    useSelectedDepartmentData,
                    [],
                );

                getAllUseSelectedDepartmentIds(useSelectedDepartmentData, allUseSelectedDepartmentIdsSetRef.current);
                getSelectableUseDepartmentIdsSetRef(
                    normalizedUSESelectedDepartmentList,
                    selectableUseDepartmentIdsSetRef.current,
                );
                selectableUseDepartmentIdsSetRef.current.add(notInSeDepartmentValue);
            }

            initAllDepartment();
        } catch (error) {
            console.error('initOnlyShowUSESelectedDepartment error', error);
        }
    };

    const initDepartmentData = () => {
        if (props.section !== SectionType.left) {
            return;
        }
        if (!isOnlyShowUSESelectedDepartment) {
            initAllDepartment();
            return;
        }
        initOnlyShowUSESelectedDepartment();
    };

    useEffect(() => {
        addBreadcrumbItem();
    }, [departmentCache]);

    useEffect(() => {
        setIsLoading?.(true);
        initDepartmentData();
    }, []);

    useEffect(() => {
        if (props.section === SectionType.left) {
            checkoutIsAllSelect(dataList);
        }
    }, [dataList]);

    useImperativeHandle(ref, () => ({
        cleanStateByParent() {
            cleanSelectedState(context, {
                isCanSelectParentDepartment,
                selectableUseDepartmentIdsSet: selectableUseDepartmentIdsSetRef.current,
            });
        },
    }));

    const computedListContentHeight = () => {
        const listContentEl = $document.querySelector(
            '.task-assign-department-select-dialog-list-panel .list-content.list-content-left',
        ) as HTMLElement;
        const bizDepartToolbarEl = $document.querySelector(
            '.task-assign-department-select-dialog-list-panel .biz-depart-toolbar',
        ) as HTMLElement;

        if (listContentEl && bizDepartToolbarEl) {
            listContentEl.style.height = `calc(100% - ${bizDepartToolbarEl.clientHeight}px - 12px)`;
        }
    };

    useEffect(() => {
        setTimeout(() => {
            adaptiveHeadRight();
        });
    }, [showDataListRight]);

    useEffect(() => {
        computedListContentHeight();
    }, [props.isAllowSelect]);

    const clsNameContent = props.clsName ? 'list-content-' + props.clsName + ' ' : ' ';
    const clsNameSearch = props.clsName ? 'list-search-' + props.clsName + ' ' : ' ';

    return (
        <div className="list-panel biz-depart-list task-assign-department-select-dialog-list-panel">
            <div className="biz-depart-toolbar">
                {props.isAllowSelect ? renderAllSelect() : null}
                <div className={clsNameSearch + ' list-search'}>{renderSearch()}</div>
            </div>
            <div
                className={`${clsNameContent} list-content ${
                    props.isAllowSelect ? 'list-content-min list-content-all-select' : 'list-content-non-all-select'
                } list-content-${props.section}`}
            >
                {props.section === 'left' ? renderListLeft() : renderListRight()}
            </div>
        </div>
    );
}

const DListView = forwardRef(DList);
export default DListView;
